<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'tryout/online/index' }">
                                Tryout
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'tryout/online/view', params: {id: tryout.id} }">
                                {{ tryout.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h3>Tryout Online {{ tryout.name }} - {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}</h3>
            </div>
        </div>
        <div class="row mb-3 justify-content-center">
            <div class="col mb-2 mb-sm-0">
                <form class="form-inline">
                    <label class="form-divider mr-2 d-none d-sm-block">Pilih Paket Soal</label>
                    <select class="form-control form-control-sm" v-model="form.filter.packageID" v-on:change="redirect">
                        <option value="">-- Default --</option>
                        <option v-for="questionPackage in tryoutSubject.packages" v-bind:value="questionPackage.id" v-bind:key="questionPackage.id">{{ questionPackage.name }}</option>
                    </select>
                </form>
            </div>
            <div class="col-auto ml-auto" v-if="roleElligibleModified()">
                <router-link v-bind:to="{ name: 'tryout/online/question/package/add', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id} }" class="btn btn-sm btn-danger pull-right">
                    Generate Paket Soal
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-9 col-sm-12">
                <div class="card shadow-sm mb-4 border-0" v-for="(question, index) in questions" v-bind:key="question.order">
                    <form v-on:submit.prevent="updateQuestion($event, index)" v-bind:ref="'question-form-' + index" disabled>
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Soal No. {{ generateOrder(index) }}
                                    </span>
                                </div>
                                <div class="col-auto" v-if="(question.content || question.choices.length) && roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0 mr-2" v-on:click="toggleInput($event)">
                                            Edit
                                        </button>
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="confirmationQuestion(question)">
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body pb-0">
                            <template v-if="question.content || question.choices.length || question.isEssay">
                                <div class="wrapper-input">
                                    <div class="row mb-3">
                                        <div class="col font-weight-bold">
                                            Deskripsi Soal
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <div class="form-group">
                                                <tinymce v-bind:id="'text-editor-question-' + index" v-model="question.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <div class="form-check form-check-inline py-1" v-for="(qtype, qtypeIndex) in ['Pilihan ganda', 'Essay', 'Tabel', 'List']" :key="qtypeIndex">
                                                <div class="custom-control custom-radio">
                                                    <input v-model="question.isEssay" type="radio" class="custom-control-input" v-bind:value="qtypeIndex" v-bind:id="'input-qtype-' + index + '-' + qtypeIndex" :name="'question-type-' + index" />
                                                    <label class="custom-control-label" v-bind:for="'input-qtype-' + index + '-' + qtypeIndex">{{ qtype }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div v-if="question.isEssay === 0" class="col font-weight-bold">
                                            Alternatif Jawaban
                                        </div>
                                        <div v-else-if="question.isEssay === 2" class="col font-weight-bold">
                                            Pengaturan Tabel Pernyataan & Kunci Jawaban
                                        </div>
                                        <div v-else-if="question.isEssay === 3" class="col font-weight-bold">
                                            Pengaturan Pilihan List & Kunci Jawaban
                                        </div>
                                    </div>

                                    <!-- start: if multiple choice -->
                                    <div v-if="question.isEssay === 0" class="row mb-4">
                                        <div class="col-12 col-md-6 mb-3" v-for="(choice, choiceIndex) in question.choices" v-bind:key="choice.order">
                                            <div class="form-group">
                                                <span class="font-weight-bold">{{ choice.order }}.</span>
                                                <div class="form-check form-check-inline ml-2">
                                                    <div class="custom-control custom-radio">
                                                        <input v-model="question.answer" v-bind:value="numberToAlphabet(choiceIndex)" type="radio" class="custom-control-input" v-bind:id="'input-choice-' + index + '-' + choiceIndex" :name="'question-choice-answer-' + index" />
                                                        <label class="custom-control-label" v-bind:for="'input-choice-' + index + '-' + choiceIndex">Jawaban Benar</label>
                                                    </div>
                                                </div>
                                                <a href="#" v-if="question.choices.length > 1" class="float-right" v-on:click.prevent="removeChoice(index, choiceIndex)">
                                                    <i class="fa fa-times text-danger"></i>
                                                </a>
                                                <div class="clearfix"></div>
                                            </div>
                                            <div class="form-group">
                                                <tinymce v-on:editorInit="initTinyMceEditChoice($event, index, choiceIndex)" v-bind:id="'text-editor-question-' + index + '-choice-' + choiceIndex" v-model="choice.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <button type="button" class="btn btn-link btn-sm px-0" v-on:click="addChoice(index)">
                                                Tambah Alternatif Jawaban +
                                            </button>
                                        </div>
                                    </div>
                                    <!-- end: if multiple choice -->

                                    <!-- start: if essay -->
                                    <div v-else-if="question.isEssay === 1">
                                        <div class="row mb-2 align-items-center">
                                            <div class="col-auto font-weight-bold">
                                                Default Answer
                                            </div>
                                            <div class="col-auto">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" :id="'essay-type-default-' + index" :name="'essay-type-' + index" value="text" v-model="question.essayType" class="custom-control-input" />
                                                    <label class="custom-control-label" :for="'essay-type-default-' + index">Default (Teks Bebas)</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" :id="'essay-type-numeric-' + index" :name="'essay-type-' + index" value="numeric" v-model="question.essayType" class="custom-control-input" />
                                                    <label class="custom-control-label text-primary font-weight-bold" :for="'essay-type-numeric-' + index">Numerik (Hanya Angka)</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="alert alert-info py-1 px-3 mb-2 small" v-if="question.essayType === 'numeric'">
                                            <i class="fa fa-info-circle mr-1"></i> <strong>Format Numerik:</strong> Kotak jawaban siswa nantinya dibatasi hanya bisa menerima input angka (0-9). Huruf dan simbol lain tidak akan bisa diketik.
                                        </div>
                                        <div class="row mb-4">
                                            <div class="col">
                                                <div class="form-group">
                                                    <tinymce v-on:editorInit="initTinyMceEditEssayDefaultAnswer($event, index)" v-bind:id="'text-editor-question-default-answer-' + index" v-model="question.defaultAnswer" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col font-weight-bold">
                                                Kunci Jawaban
                                            </div>
                                        </div>
                                        <div class="row mb-4">
                                            <div class="col">
                                                <div class="form-group">
                                                    <tinymce v-on:editorInit="initTinyMceEditEssayAnswer($event, index)" v-bind:id="'text-editor-question-answer-' + index" v-model="question.answer" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end: if essay -->

                                    <!-- start: if table -->
                                    <div v-else-if="question.isEssay === 2" class="mb-4">
                                        <div class="card bg-light border p-3 mb-3" v-if="question.tableData">
                                            <div class="row">
                                                <div class="col-12 col-md-4 mb-2">
                                                    <label class="font-weight-bold small text-muted">Label Kolom Pernyataan</label>
                                                    <input type="text" class="form-control form-control-sm" v-model="question.tableData.colStatement" placeholder="Misal: Tanggapan / Pernyataan" />
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                    <label class="font-weight-bold small text-muted">Label Pilihan 1 (Kiri)</label>
                                                    <input type="text" class="form-control form-control-sm" v-model="question.tableData.col1" placeholder="Misal: Benar / Setuju / Tepat" />
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                    <label class="font-weight-bold small text-muted">Label Pilihan 2 (Kanan)</label>
                                                    <input type="text" class="form-control form-control-sm" v-model="question.tableData.col2" placeholder="Misal: Salah / Tidak Setuju / Kurang Tepat" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-responsive" v-if="question.tableData">
                                            <table class="table table-bordered bg-white">
                                                <thead class="thead-light">
                                                    <tr>
                                                        <th style="width: 50px;" class="text-center">No</th>
                                                        <th>{{ question.tableData.colStatement || 'Pernyataan' }}</th>
                                                        <th style="width: 140px;" class="text-center">{{ question.tableData.col1 || 'Benar' }}</th>
                                                        <th style="width: 140px;" class="text-center">{{ question.tableData.col2 || 'Salah' }}</th>
                                                        <th style="width: 50px;" class="text-center">Aksi</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, rIdx) in question.tableData.rows" :key="'tbl-edit-row-' + index + '-' + (row._uid || rIdx)">
                                                        <td class="text-center font-weight-bold align-middle">{{ rIdx + 1 }}</td>
                                                        <td class="p-2">
                                                            <tinymce v-on:editorInit="initTinyMceEditTableRow($event, row, index, rIdx)" v-bind:id="'text-editor-tbl-' + index + '-row-' + (row._uid || rIdx)" v-model="row.statement" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                        </td>
                                                        <td class="text-center align-middle">
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" :id="'tbl-edit-' + index + '-' + rIdx + '-c1'" :name="'tbl-edit-radio-' + index + '-' + rIdx" value="col1" v-model="row.key" class="custom-control-input" />
                                                                <label class="custom-control-label font-weight-bold text-primary" :for="'tbl-edit-' + index + '-' + rIdx + '-c1'">Kunci</label>
                                                            </div>
                                                        </td>
                                                        <td class="text-center align-middle">
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" :id="'tbl-edit-' + index + '-' + rIdx + '-c2'" :name="'tbl-edit-radio-' + index + '-' + rIdx" value="col2" v-model="row.key" class="custom-control-input" />
                                                                <label class="custom-control-label font-weight-bold text-danger" :for="'tbl-edit-' + index + '-' + rIdx + '-c2'">Kunci</label>
                                                            </div>
                                                        </td>
                                                        <td class="text-center align-middle">
                                                            <button type="button" class="btn btn-link text-danger p-0" v-if="question.tableData.rows.length > 1" @click="removeTableRow(true, index, rIdx)">
                                                                <i class="fa fa-times fa-lg"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <button type="button" class="btn btn-outline-danger btn-sm mt-1" @click="addTableRow(true, index)">
                                            + Tambah Baris Pernyataan
                                        </button>
                                    </div>
                                    <!-- end: if table -->

                                    <!-- start: if list -->
                                    <div v-else-if="question.isEssay === 3" class="mb-4">
                                        <div class="alert alert-info py-2 px-3 mb-3 small">
                                            <strong>Pilihan Ganda Kompleks:</strong> Centang kotak pada opsi yang merupakan jawaban benar (bisa lebih dari satu).
                                        </div>
                                        <div class="list-group mb-2" v-if="question.listData">
                                            <div class="list-group-item bg-white p-3 mb-2 border rounded" v-for="(item, iIdx) in question.listData.items" :key="'list-edit-item-' + index + '-' + (item._uid || iIdx)">
                                                <div class="d-flex align-items-start">
                                                    <div class="custom-control custom-checkbox mr-3 mt-2">
                                                        <input type="checkbox" class="custom-control-input" :id="'list-edit-' + index + '-' + iIdx" v-model="item.isCorrect" />
                                                        <label class="custom-control-label font-weight-bold text-success" :for="'list-edit-' + index + '-' + iIdx">
                                                            Kunci Benar
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1 mr-2">
                                                        <tinymce v-on:editorInit="initTinyMceEditListItem($event, item, index, iIdx)" v-bind:id="'text-editor-list-' + index + '-item-' + (item._uid || iIdx)" v-model="item.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                    </div>
                                                    <button type="button" class="btn btn-link text-danger p-0 ml-2 mt-2" v-if="question.listData.items.length > 1" @click="removeListItem(true, index, iIdx)">
                                                        <i class="fa fa-times fa-lg"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-outline-danger btn-sm mt-1" @click="addListItem(true, index)">
                                            + Tambah Pilihan Item
                                        </button>
                                    </div>
                                    <!-- end: if list -->
                                    <!-- end: if multiple choice -->
                                    <div class="row justify-content-end">
                                        <div class="ml-auto col-auto">
                                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="toggle-input">
                                    <div class="row mb-3">
                                        <div class="col-sm-7 font-weight-bold">
                                            Deskripsi Soal 
                                        </div>
                                        <div class="col-sm-5 font-weight-bold d-none d-sm-block">
                                            {{ question.isEssay === 1 ? (question.essayType === 'numeric' ? 'Jawaban Essay (Numerik)' : 'Jawaban Essay') : (question.isEssay === 2 ? 'Kunci Tabel' : (question.isEssay === 3 ? 'Kunci List' : 'Opsi Jawaban')) }}
                                        </div>
                                    </div>
                                    <div class="row justify-content-end mb-3">
                                        <div class="col-12 col-sm-7 question-content-wrap" v-html="question.content"></div>
                                        <div class="col-12 col-sm-5">
                                            <!-- start if essay / table / list -->
                                            <div v-if="question.isEssay" class="locked-answer-view" style="width: 100%; max-width: 100%; overflow: visible; cursor: default !important;">
                                                <div v-html="question.answer"></div>
                                            </div>
                                            <!-- end if essay / table / list -->

                                            <!-- start if multiple choice -->
                                            <div v-else class="row" v-for="choice in question.choices" v-bind:key="choice.order">
                                                <div class="col-auto pr-1">
                                                    {{ choice.order }}.
                                                </div>
                                                <div class="col pl-1">
                                                    <div class="text-success font-weight-bold" v-if="question.answer === choice.order">Jawaban Benar</div>
                                                    <span v-html="choice.content"></span>
                                                </div>
                                            </div>
                                            <!-- end if multiple choice -->
                                            <div class="row mt-3">
                                                <div class="col-auto font-weight-bold">
                                                    Persentase Siswa Benar: 
                                                    <percentage v-bind:value="question.correctPercentage"></percentage>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </form>
                    <template v-if="!question.content && !question.choices.length && !question.isEssay && !form.filter.packageID">
                        <div class="card-body py-0">
                            <form v-on:submit.prevent="addQuestion" disabled>
                                <div class="edit-action">
                                    <button class="btn btn-danger btn-sm px-5" type="button" v-on:click="initCreateForm(question.order); toggleInput($event)">
                                        Buat Soal
                                    </button>
                                </div>
                                <div class="wrapper-input">
                                    <div class="row mb-3">
                                        <div class="col font-weight-bold">
                                            Deskripsi Soal
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <div class="form-group">
                                                <tinymce v-bind:id="'text-editor-question-' + index" v-model="form.question.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col font-weight-bold" v-if="form.question.isEssay === 0">
                                            Alternatif Jawaban
                                        </div>
                                        <div class="col font-weight-bold" v-else-if="form.question.isEssay === 2">
                                            Pengaturan Tabel Pernyataan & Kunci Jawaban
                                        </div>
                                        <div class="col font-weight-bold" v-else-if="form.question.isEssay === 3">
                                            Pengaturan Pilihan List & Kunci Jawaban
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <div class="form-check form-check-inline py-1" v-for="(qtype, qtypeIndex) in ['Pilihan ganda', 'Essay', 'Tabel', 'List']" :key="qtypeIndex">
                                                <div class="custom-control custom-radio">
                                                    <input v-model="form.question.isEssay" type="radio" class="custom-control-input" v-bind:value="qtypeIndex" v-bind:id="'input-create-qtype-' + qtypeIndex" name="question-create-type" />
                                                    <label class="custom-control-label" v-bind:for="'input-create-qtype-' + qtypeIndex">{{ qtype }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- start if multiple choice -->
                                    <div v-if="form.question.isEssay === 0" class="row mb-4">
                                        <div class="col-12 col-md-6 mb-3" v-for="(choice, choiceIndex) in form.question.choices" v-bind:key="choice.order">
                                            <div class="form-group">
                                                <span class="font-weight-bold">{{ choice.order }}.</span>
                                                <div class="form-check form-check-inline ml-2">
                                                    <div class="custom-control custom-radio">
                                                        <input v-model="form.question.answer" v-bind:value="numberToAlphabet(choiceIndex)" type="radio" class="custom-control-input" v-bind:id="'input-create-choice-' + choiceIndex" name="question-create-choice-answer" />
                                                        <label class="custom-control-label" v-bind:for="'input-create-choice-' + choiceIndex">Jawaban Benar</label>
                                                    </div>
                                                </div>
                                                <a href="#" v-if="form.question.choices.length > 1" class="float-right" v-on:click.prevent="removeChoice(false, choiceIndex)">
                                                    <i class="fa fa-times text-danger"></i>
                                                </a>
                                                <div class="clearfix"></div>
                                            </div>
                                            <div class="form-group">
                                                <tinymce v-on:editorInit="initTinyMceCreateChoice($event, choiceIndex)" v-bind:id="'text-editor-question-' + index + '-choice-' + choiceIndex" v-model="choice.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <button type="button" class="btn btn-link btn-sm px-0" v-on:click="addChoice()">
                                                Tambah Alternatif Jawaban +
                                            </button>
                                        </div>
                                    </div>
                                    <!-- end if multiple choice -->

                                    <!-- start if essay -->
                                    <div v-else-if="form.question.isEssay === 1">
                                        <div class="row mb-2 align-items-center">
                                            <div class="col-auto font-weight-bold">
                                                Default Answer
                                            </div>
                                            <div class="col-auto">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="create-essay-type-default" name="create-essay-type" value="text" v-model="form.question.essayType" class="custom-control-input" />
                                                    <label class="custom-control-label" for="create-essay-type-default">Default (Teks Bebas)</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="create-essay-type-numeric" name="create-essay-type" value="numeric" v-model="form.question.essayType" class="custom-control-input" />
                                                    <label class="custom-control-label text-primary font-weight-bold" for="create-essay-type-numeric">Numerik (Hanya Angka)</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="alert alert-info py-1 px-3 mb-2 small" v-if="form.question.essayType === 'numeric'">
                                            <i class="fa fa-info-circle mr-1"></i> <strong>Format Numerik:</strong> Kotak jawaban siswa nantinya dibatasi hanya bisa menerima input angka (0-9). Huruf dan simbol lain tidak akan bisa diketik.
                                        </div>
                                        <div class="row mb-4">
                                            <div class="col">
                                                <div class="form-group">
                                                    <tinymce v-on:editorInit="initTinyMceCreateEssayDefaultAnswer" v-bind:id="'text-editor-question-default-answer'" v-model="form.question.defaultAnswer" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col font-weight-bold">
                                                Kunci Jawaban
                                            </div>
                                        </div>
                                        <div class="row mb-4">
                                            <div class="col">
                                                <div class="form-group">
                                                    <tinymce v-on:editorInit="initTinyMceCreateEssayAnswer" v-bind:id="'text-editor-question-answer'" v-model="form.question.answer" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end if essay -->

                                    <!-- start if table -->
                                    <div v-else-if="form.question.isEssay === 2" class="mb-4">
                                        <div class="card bg-light border p-3 mb-3" v-if="form.question.tableData">
                                            <div class="row">
                                                <div class="col-12 col-md-4 mb-2">
                                                    <label class="font-weight-bold small text-muted">Label Kolom Pernyataan</label>
                                                    <input type="text" class="form-control form-control-sm" v-model="form.question.tableData.colStatement" placeholder="Misal: Tanggapan / Pernyataan" />
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                    <label class="font-weight-bold small text-muted">Label Pilihan 1 (Kiri)</label>
                                                    <input type="text" class="form-control form-control-sm" v-model="form.question.tableData.col1" placeholder="Misal: Benar / Setuju / Tepat" />
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                    <label class="font-weight-bold small text-muted">Label Pilihan 2 (Kanan)</label>
                                                    <input type="text" class="form-control form-control-sm" v-model="form.question.tableData.col2" placeholder="Misal: Salah / Tidak Setuju / Kurang Tepat" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-responsive" v-if="form.question.tableData">
                                            <table class="table table-bordered bg-white">
                                                <thead class="thead-light">
                                                    <tr>
                                                        <th style="width: 50px;" class="text-center">No</th>
                                                        <th>{{ form.question.tableData.colStatement || 'Pernyataan' }}</th>
                                                        <th style="width: 140px;" class="text-center">{{ form.question.tableData.col1 || 'Benar' }}</th>
                                                        <th style="width: 140px;" class="text-center">{{ form.question.tableData.col2 || 'Salah' }}</th>
                                                        <th style="width: 50px;" class="text-center">Aksi</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, rIdx) in form.question.tableData.rows" :key="'tbl-create-row-' + (row._uid || rIdx)">
                                                        <td class="text-center font-weight-bold align-middle">{{ rIdx + 1 }}</td>
                                                        <td class="p-2">
                                                            <tinymce v-on:editorInit="initTinyMceCreateTableRow($event, row, rIdx)" v-bind:id="'text-editor-tbl-create-row-' + (row._uid || rIdx)" v-model="row.statement" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                        </td>
                                                        <td class="text-center align-middle">
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" :id="'tbl-create-' + rIdx + '-c1'" :name="'tbl-create-radio-' + rIdx" value="col1" v-model="row.key" class="custom-control-input" />
                                                                <label class="custom-control-label font-weight-bold text-primary" :for="'tbl-create-' + rIdx + '-c1'">Kunci</label>
                                                            </div>
                                                        </td>
                                                        <td class="text-center align-middle">
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" :id="'tbl-create-' + rIdx + '-c2'" :name="'tbl-create-radio-' + rIdx" value="col2" v-model="row.key" class="custom-control-input" />
                                                                <label class="custom-control-label font-weight-bold text-danger" :for="'tbl-create-' + rIdx + '-c2'">Kunci</label>
                                                            </div>
                                                        </td>
                                                        <td class="text-center align-middle">
                                                            <button type="button" class="btn btn-link text-danger p-0" v-if="form.question.tableData.rows.length > 1" @click="removeTableRow(false, null, rIdx)">
                                                                <i class="fa fa-times fa-lg"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <button type="button" class="btn btn-outline-danger btn-sm mt-1" @click="addTableRow(false)">
                                            + Tambah Baris Pernyataan
                                        </button>
                                    </div>
                                    <!-- end if table -->

                                    <!-- start if list -->
                                    <div v-else-if="form.question.isEssay === 3" class="mb-4">
                                        <div class="alert alert-info py-2 px-3 mb-3 small">
                                             <strong>Pilihan Ganda Kompleks:</strong> Centang kotak pada opsi yang merupakan jawaban benar (bisa lebih dari satu).
                                        </div>
                                        <div class="list-group mb-2" v-if="form.question.listData">
                                            <div class="list-group-item bg-white p-3 mb-2 border rounded" v-for="(item, iIdx) in form.question.listData.items" :key="'list-create-item-' + (item._uid || iIdx)">
                                                <div class="d-flex align-items-start">
                                                    <div class="custom-control custom-checkbox mr-3 mt-2">
                                                        <input type="checkbox" class="custom-control-input" :id="'list-create-' + iIdx" v-model="item.isCorrect" />
                                                        <label class="custom-control-label font-weight-bold text-success" :for="'list-create-' + iIdx">
                                                            Kunci Benar
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1 mr-2">
                                                        <tinymce v-on:editorInit="initTinyMceCreateListItem($event, item, iIdx)" v-bind:id="'text-editor-list-create-item-' + (item._uid || iIdx)" v-model="item.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                    </div>
                                                    <button type="button" class="btn btn-link text-danger p-0 ml-2 mt-2" v-if="form.question.listData.items.length > 1" @click="removeListItem(false, null, iIdx)">
                                                        <i class="fa fa-times fa-lg"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-outline-danger btn-sm mt-1" @click="addListItem(false)">
                                            + Tambah Pilihan Item
                                        </button>
                                    </div>
                                    <!-- end if list -->
                                    <div class="row justify-content-end">
                                        <div class="ml-auto col-auto">
                                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </template>
                    <div class="card-body">
                        <template v-if="question.solution">
                            <form v-on:submit.prevent="updateSolution($event, index)" disabled>
                                <div class="row justify-content-end">
                                    <div class="col font-weight-bold mb-2">
                                        Pembahasan 
                                    </div>
                                    <div class="ml-auto col-auto" v-if="roleElligibleModified()">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0 mr-2" v-on:click="toggleInput($event)">
                                                Edit
                                            </button>
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="confirmationSolution(question.solution)">
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="wrapper-input">
                                            <div class="form-group">
                                                <div class="row mb-4">
                                                    <div class="col">
                                                        <tinymce v-bind:id="'text-editor-solution-' + index" v-model="question.solution.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-end">
                                                    <div class="ml-auto col-auto">
                                                        <button type="submit" class="btn btn-danger btn-sm px-5">
                                                            Save
                                                        </button>
                                                        <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput">
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="toggle-input" v-html="question.solution.content"></div>
                                    </div>
                                </div>
                            </form>
                        </template>
                        <template v-else-if="question.id && roleElligibleModified()">
                            <form v-on:submit.prevent="addSolution" disabled>
                                <div class="edit-action">
                                    <button class="btn btn-danger btn-sm px-3" type="button" v-on:click="form.solution = {questionID: question.id, content: ''}; toggleInput($event)">
                                        Buat Pembahasan
                                    </button>
                                </div>
                                <div class="wrapper-input">
                                    <div class="row">
                                        <div class="col font-weight-bold mb-2">
                                            Pembahasan 
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row mb-4">
                                            <div class="col">
                                                <tinymce v-bind:id="'text-editor-solution-' + index" v-model="form.solution.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row justify-content-end">
                                        <div class="ml-auto col-auto">
                                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-xl-9 col-sm-12 mb-4">
                <nav class="float-right">
                    <!-- Native Page Link -->
                    <ul class="pagination pagination-sm justify-content-start flex-wrap">
                        <li class="page-item" v-bind:class="{active: page === pageNumber}" v-for="pageNumber in pageCount">
                            <a v-bind:href="$router.resolve({name: 'tryout/online/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id, page: pageNumber || null, packageID: form.filter.packageID || null}}).href" class="page-link" tabindex="0">
                                {{ pageNumber }}
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <b-modal v-if="roleElligibleModified()" v-model="modal.question" v-on:hide="remove.question = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus soal ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="removeQuestion">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.question = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal v-if="roleElligibleModified()" v-model="modal.solution" v-on:hide="remove.solution = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus pembahasan soal ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="removeSolution">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.solution = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Paginate from 'vuejs-paginate';
    import tinymce from 'vue-tinymce-editor';
    import Percentage from "@/components/item/Percentage";
    import { tinyMCEOptions } from '@/params.js';

    /**
     * @param {Object} tryoutSubject
     */
    export default {
        name: "TryoutOnlineQuestionView",
        components: {
            Paginate,
            Percentage,
            tinymce
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    solution: {
                        content: '',
                        questionID: ''
                    },
                    question: {
                        content: '',
                        order: '',
                        answer: '',
                        choices: [],
                        isEssay: 0,
                        essayType: 'text',
                        defaultAnswer: '',
                        tableData: null,
                        listData: null,
                    },
                    filter: {
                        packageID: ''
                    }
                },
                tryout: {},
                tryoutSubject: {subject: {}},
                questions: [],
                modal: {
                    question: false,
                    solution: false
                },
                remove: {
                    question: null,
                    solution: null
                },
                pageCount: 0,
                page: 1,
                perPage: 1,
                tinyMCEOptions: tinyMCEOptions
            };
        },
        methods: {
            confirmationQuestion(model) {
                this.modal.question = true;
                this.remove.question = model;
            },
            confirmationSolution(model) {
                this.modal.solution = true;
                this.remove.solution = model;
            },
            removeQuestion() {
                this.axios.post(process.env.API_URL + '/question/delete/' + this.remove.question.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.paginate(this.page);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal.question = false;
                    this.remove.question = null;
                });
            },
            removeSolution() {
                this.axios.post(process.env.API_URL + '/solution/delete/' + this.remove.solution.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.paginate(this.page);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal.solution = false;
                    this.remove.solution = null;
                });
            },
            generateOrder(index) {
                return index + 1 + ((this.page - 1) * this.perPage);
            },
            numberToAlphabet(number) {
                return String.fromCharCode(97 + number).toUpperCase();
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.paginate(this.page);
                    }
                } else {
                    this.paginate(this.page);
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            addQuestion(event) {
                // Sync TinyMCE instance content ke statement/content
                if (this.form.question.isEssay === 2 && this.form.question.tableData && this.form.question.tableData.rows) {
                    this.form.question.tableData.rows.forEach((row, rIdx) => {
                        const editorId = 'text-editor-tbl-create-row-' + (row._uid || rIdx);
                        const ed = window.tinymce && window.tinymce.get(editorId);
                        if (ed) {
                            row.statement = ed.getContent();
                        }
                    });
                } else if (this.form.question.isEssay === 3 && this.form.question.listData && this.form.question.listData.items) {
                    this.form.question.listData.items.forEach((item, iIdx) => {
                        const editorId = 'text-editor-list-create-item-' + (item._uid || iIdx);
                        const ed = window.tinymce && window.tinymce.get(editorId);
                        if (ed) {
                            item.content = ed.getContent();
                        }
                    });
                }

                if (this.form.question.isEssay || this.form.question.choices.find(choice => choice.order === this.form.question.answer)) {
                    let payload = Object.assign({}, this.form.question, { tryoutSubjectID: this.tryoutSubject.id });

                    // Handle Tabel
                    if (this.form.question.isEssay === 2) {
                        if (!this.form.question.tableData || !this.form.question.tableData.rows.length) {
                            this.$toastr('warning', 'Tambahkan minimal 1 baris pernyataan untuk soal tipe Tabel', 'Warning');
                            return;
                        }
                        const { defaultAnswer, answer } = this.generateTableHTML(this.form.question.tableData);
                        this.form.question.defaultAnswer = defaultAnswer;
                        this.form.question.answer = answer;
                        payload.defaultAnswer = defaultAnswer;
                        payload.answer = answer;
                        payload.isEssay = 1; // Simpan ke DB sebagai isEssay=1 agar kompatibel
                    }
                    // Handle List
                    else if (this.form.question.isEssay === 3) {
                        if (!this.form.question.listData || !this.form.question.listData.items.length) {
                            this.$toastr('warning', 'Tambahkan minimal 1 item pilihan untuk soal tipe List', 'Warning');
                            return;
                        }
                        if (!this.form.question.listData.items.some(item => item.isCorrect)) {
                            this.$toastr('warning', 'Pilih minimal 1 jawaban benar untuk soal tipe List', 'Warning');
                            return;
                        }
                        const { defaultAnswer, answer } = this.generateListHTML(this.form.question.listData);
                        this.form.question.defaultAnswer = defaultAnswer;
                        this.form.question.answer = answer;
                        payload.defaultAnswer = defaultAnswer;
                        payload.answer = answer;
                        payload.isEssay = 1; // Simpan ke DB sebagai isEssay=1 agar kompatibel
                    }
                    // Handle Essay biasa & Numerik
                    else if (this.form.question.isEssay === 1) {
                        const editor = window.tinymce.get('text-editor-question-answer');
                        if (editor) {
                            const editorBody = editor.getBody().cloneNode(true);
                            if (editorBody) {
                                editorBody.querySelectorAll('input').forEach(input => {
                                    if (input.type === 'checkbox' || input.type === 'radio') {
                                        if (input.checked) {
                                            input.setAttribute('checked', 'checked');
                                        } else {
                                            input.removeAttribute('checked');
                                        }
                                    } else {
                                        input.setAttribute('value', input.value);
                                    }
                                });
                                this.form.question.answer = editorBody.innerHTML;
                                payload.answer = editorBody.innerHTML;
                            }
                        }

                        const defaultEd = window.tinymce.get('text-editor-question-default-answer');
                        let defAns = defaultEd ? defaultEd.getContent() : (this.form.question.defaultAnswer || '');
                        defAns = defAns.replace(/<div[^>]*class="essay-numeric-input"[^>]*>/gi, '').replace(/<div[^>]*data-numeric="true"[^>]*>/gi, '').replace(/<\/div>/gi, '').trim();

                        if (this.form.question.essayType === 'numeric') {
                            payload.defaultAnswer = '<div data-numeric="true" class="essay-numeric-input">' + defAns + '</div>';
                        } else {
                            payload.defaultAnswer = defAns;
                        }
                        this.form.question.defaultAnswer = payload.defaultAnswer;
                    }
                    this.axios.post(process.env.API_URL + '/question', payload).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            location.reload();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    }).catch(error => {
                        const msg = (error.response && error.response.data && error.response.data.message) || error.message || 'Gagal menyimpan soal';
                        this.$toastr('error', msg, 'Error');
                    });
                } else {
                    this.$toastr('warning', 'Answer not set', 'Warning');
                }
            },
            updateQuestion(event, index) {
                let question = this.questions[index];
                if (question) {
                    const qEd = window.tinymce && window.tinymce.get('text-editor-question-' + index);
                    if (qEd) {
                        question.content = qEd.getContent();
                    }

                    // Sync TinyMCE instance content ke statement/content
                    if (question.isEssay === 2 && question.tableData && question.tableData.rows) {
                        question.tableData.rows.forEach((row, rIdx) => {
                            const editorId = 'text-editor-tbl-' + index + '-row-' + (row._uid || rIdx);
                            const ed = window.tinymce && window.tinymce.get(editorId);
                            if (ed) {
                                row.statement = ed.getContent();
                            }
                        });
                    } else if (question.isEssay === 3 && question.listData && question.listData.items) {
                        question.listData.items.forEach((item, iIdx) => {
                            const editorId = 'text-editor-list-' + index + '-item-' + (item._uid || iIdx);
                            const ed = window.tinymce && window.tinymce.get(editorId);
                            if (ed) {
                                item.content = ed.getContent();
                            }
                        });
                    }

                    if (question.isEssay || question.choices.find(choice => choice.order === question.answer)) {
                        let payload = Object.assign({}, question);

                        // Handle Tabel
                        if (question.isEssay === 2) {
                            if (!question.tableData || !question.tableData.rows.length) {
                                this.$toastr('warning', 'Tambahkan minimal 1 baris pernyataan untuk soal tipe Tabel', 'Warning');
                                return;
                            }
                            const { defaultAnswer, answer } = this.generateTableHTML(question.tableData);
                            question.defaultAnswer = defaultAnswer;
                            question.answer = answer;
                            payload.defaultAnswer = defaultAnswer;
                            payload.answer = answer;
                            payload.isEssay = 1; // Simpan ke DB sebagai isEssay=1
                        }
                        // Handle List
                        else if (question.isEssay === 3) {
                            if (!question.listData || !question.listData.items.length) {
                                this.$toastr('warning', 'Tambahkan minimal 1 item pilihan untuk soal tipe List', 'Warning');
                                return;
                            }
                            if (!question.listData.items.some(item => item.isCorrect)) {
                                this.$toastr('warning', 'Pilih minimal 1 jawaban benar untuk soal tipe List', 'Warning');
                                return;
                            }
                            const { defaultAnswer, answer } = this.generateListHTML(question.listData);
                            question.defaultAnswer = defaultAnswer;
                            question.answer = answer;
                            payload.defaultAnswer = defaultAnswer;
                            payload.answer = answer;
                            payload.isEssay = 1; // Simpan ke DB sebagai isEssay=1
                        }
                        // Handle Essay biasa & Numerik
                        else if (question.isEssay === 1) {
                            const editor = window.tinymce.get('text-editor-question-answer-' + index) || window.tinymce.get('text-editor-question-answer');
                            if (editor) {
                                const editorBody = editor.getBody().cloneNode(true);
                                if (editorBody) {
                                    editorBody.querySelectorAll('input').forEach(input => {
                                        if (input.type === 'checkbox' || input.type === 'radio') {
                                            if (input.checked) {
                                                input.setAttribute('checked', 'checked');
                                            } else {
                                                input.removeAttribute('checked');
                                            }
                                        } else {
                                            input.setAttribute('value', input.value);
                                        }
                                    });
                                    question.answer = editorBody.innerHTML;
                                    payload.answer = editorBody.innerHTML;
                                }
                            }

                            const defaultEd = window.tinymce.get('text-editor-question-default-answer-' + index) || window.tinymce.get('text-editor-question-default-answer');
                            let defAns = defaultEd ? defaultEd.getContent() : (question.defaultAnswer || '');
                            defAns = defAns.replace(/<div[^>]*class="essay-numeric-input"[^>]*>/gi, '').replace(/<div[^>]*data-numeric="true"[^>]*>/gi, '').replace(/<\/div>/gi, '').trim();

                            if (question.essayType === 'numeric') {
                                payload.defaultAnswer = '<div data-numeric="true" class="essay-numeric-input">' + defAns + '</div>';
                            } else {
                                payload.defaultAnswer = defAns;
                            }
                            question.defaultAnswer = payload.defaultAnswer;
                        }
                        this.axios.post(process.env.API_URL + '/question/update/' + question.id, payload).then(response => {
                            if (response.data.status) {
                                this.$toastr('success', response.data.message, 'Success');
                                this.toggleInput(event);
                                this.paginate(this.page);
                            } else {
                                this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                            }
                        }).catch(error => {
                            const msg = (error.response && error.response.data && error.response.data.message) || error.message || 'Gagal memperbarui soal';
                            this.$toastr('error', msg, 'Error');
                        });
                    } else {
                        this.$toastr('warning', 'Answer not set', 'Warning');
                    }
                }
            },
                addSolution(event) {
                this.axios.post(process.env.API_URL + '/solution', this.form.solution).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
//                        this.toggleInput(event);
                        location.reload();
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            updateSolution(event, index) {
                let question = this.questions[index];
                if (question && question.solution) {
                    this.axios.post(process.env.API_URL + '/solution/update/' + question.solution.id, question.solution).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.toggleInput(event);
                            this.paginate(this.page);
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                }
            },
            addChoice(index) {
                if (Number.isInteger(index)) {
                    let question = this.questions[index];
                    if (question) {
                        var total = question.choices.push({
                            order: '',
                            content: ''
                        });
                        question.choices[total - 1].order = this.numberToAlphabet(total - 1);
                    }
                } else {
                    var total = this.form.question.choices.push({
                        order: this.numberToAlphabet(index),
                        content: ''
                    });
                    this.form.question.choices[total - 1].order = this.numberToAlphabet(total - 1);
                }
            },
            removeChoice(questionIndex, index) {
                if (Number.isInteger(questionIndex)) {
                    let choices = this.questions[questionIndex].choices;
                    let choice = choices[index];
                    if (choice.id) {
                        if (confirm('Hapus opsi jawaban? Opsi jawaban tidak dapat dikembalikan.')) {
                            this.axios.post(process.env.API_URL + '/choice/delete/' + choice.id).then(response => {
                                if (response.data.status) {
                                    this.$toastr('success', response.data.message, 'Success');

                                    choices.splice(index, 1);
                                    this.questions[questionIndex].choices = this.normalizeChoice(choices);
                                } else {
                                    this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                                }
                            });
                        }
                    } else {
                        choices.splice(index, 1);
                        this.questions[questionIndex].choices = this.normalizeChoice(choices);
                    }
                } else {
                    let choices = this.form.question.choices;
                    choices.splice(index, 1);
                    this.form.question.choices = this.normalizeChoice(choices);
                }
            },
            normalizeChoice(choices) {
                let i = 0;
                let newChoices = [];
                while (i < choices.length) {
                    if (choices[i]) {
                        newChoices.push(Object.assign({}, choices[i], {order: this.numberToAlphabet(i)}));
                        i++;
                    }
                }
                return newChoices;
            },
            paginate(page) {
            this.axios.get(process.env.API_URL + '/question', { params: Object.assign({}, this.form.filter, { tryoutSubjectID: this.tryoutSubject.id, page: page, limit: this.perPage }) }).then(response => {
                let questions = [];
                for (let i = 0; i < this.perPage; i++) {
                    let number = this.generateOrder(i);
                    if (number <= this.tryoutSubject.totalQuestion) {
                        let question = response.data.data.find(question => {
                            let currentOrder = question.order;
                            if (this.form.filter.packageID && question.packageQuestions && question.packageQuestions.length) {
                                currentOrder = question.packageQuestions[0].order;
                            }
                            return currentOrder === number;
                        });
                        // Smart parser: deteksi soal lama tabel/list dari HTML
                        if (question) {
                            question = this.parseQuestionData(question);
                        }
                        questions.push(question || { order: number, choices: [] });
                    }
                }
                this.questions = questions;

                this.$nextTick(() => {
                    const editor = window.tinymce.get('text-editor');
                    if (editor) {
                        editor.setContent(this.form.answer.value || '');
                    }
                });
            });
        },
            redirect() {
                location.href = this.$router.resolve({name: 'tryout/online/question/view', params: {id: this.tryout.id, tryoutSubjectID: this.tryoutSubject.id, page: this.page || null, packageID: this.form.filter.packageID || null}}).href;
            },
            overrideTinyMCEOptions() {
                this.tinyMCEOptions = Object.assign({}, this.tinyMCEOptions, {
                    file_picker_callback: function (callback) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');
                        input.style.visibility = 'hidden';
                        input.style.position = 'absolute';

                        input.onchange = function () {
                            var file = input.files[0];
                            if (file) {
                                let formData = new FormData;
                                formData.set('image', file);
                                this.axios.post(process.env.API_URL + '/solution/uploadImage', formData).then(response => {
                                    if (response.data.status) {
                                        callback(response.data.location, {alt: file.name});
                                    }
                                });
                            }
                        }.bind(this);
                        input.click();
                    }.bind(this)
                });
            },
            roleElligibleModified() {
                return this.profile && this.profile.isAdmin;
            },
            initTinyMceEditChoice(e, index, choiceIndex) {
                e.setContent(this.questions[index].choices[choiceIndex].content);
            },
            initTinyMceEditEssayDefaultAnswer(e, index) {
                if (typeof index !== 'undefined' && this.questions[index]) {
                    e.setContent(this.questions[index].defaultAnswer || '');
                } else if (this.questions[0]) {
                    e.setContent(this.questions[0].defaultAnswer || '');
                }
            },
            initTinyMceEditEssayAnswer(e, index) {
                if (typeof index !== 'undefined' && this.questions[index]) {
                    e.setContent(this.questions[index].answer || '');
                } else if (this.questions[0]) {
                    e.setContent(this.questions[0].answer || '');
                }
            },
            initTinyMceCreateChoice(e, choiceIndex) {
                e.setContent(this.form.question.choices[choiceIndex].content);
            },
            initTinyMceCreateEssayDefaultAnswer(e) {
                e.setContent(this.form.question.defaultAnswer);
            },
            initTinyMceCreateEssayAnswer(e) {
                e.setContent(this.form.question.answer);
            },
            initTinyMceEditTableRow(e, row, index, rIdx) {
                if (row && typeof row.statement !== 'undefined') {
                    e.setContent(row.statement || '');
                } else if (this.questions[index] && this.questions[index].tableData && this.questions[index].tableData.rows[rIdx]) {
                    e.setContent(this.questions[index].tableData.rows[rIdx].statement || '');
                }
            },
            initTinyMceCreateTableRow(e, row, rIdx) {
                if (row && typeof row.statement !== 'undefined') {
                    e.setContent(row.statement || '');
                } else if (this.form.question.tableData && this.form.question.tableData.rows[rIdx]) {
                    e.setContent(this.form.question.tableData.rows[rIdx].statement || '');
                }
            },
            initTinyMceEditListItem(e, item, index, iIdx) {
                if (item && typeof item.content !== 'undefined') {
                    e.setContent(item.content || '');
                } else if (this.questions[index] && this.questions[index].listData && this.questions[index].listData.items[iIdx]) {
                    e.setContent(this.questions[index].listData.items[iIdx].content || '');
                }
            },
            initTinyMceCreateListItem(e, item, iIdx) {
                if (item && typeof item.content !== 'undefined') {
                    e.setContent(item.content || '');
                } else if (this.form.question.listData && this.form.question.listData.items[iIdx]) {
                    e.setContent(this.form.question.listData.items[iIdx].content || '');
                }
            },
            generateUID(prefix = 'uid') {
                return prefix + '_' + Math.random().toString(36).substr(2, 7) + '_' + Date.now().toString(36);
            },

            // ==========================================
            // METHODS BARU: Table & List Question Types
            // ==========================================

            /**
             * Inisialisasi form saat klik "Buat Soal"
             */
            initCreateForm(order) {
                this.form.question = {
                    content: '',
                    order: order,
                    answer: '',
                    choices: [{ order: 'A', content: '' }, { order: 'B', content: '' }, { order: 'C', content: '' }, { order: 'D', content: '' }],
                    isEssay: 0,
                    essayType: 'text',
                    defaultAnswer: '',
                    tableData: {
                        colStatement: '',
                        col1: 'Benar',
                        col2: 'Salah',
                        rows: [{ _uid: this.generateUID('row'), statement: '', key: 'col1' }]
                    },
                    listData: {
                        items: [
                            { _uid: this.generateUID('item'), content: '', isCorrect: false },
                            { _uid: this.generateUID('item'), content: '', isCorrect: false }
                        ]
                    }
                };
            },

            /**
             * Tambah baris pernyataan di tabel
             * @param {boolean} isEdit - true jika mode edit, false jika mode create
             * @param {number|null} questionIndex - index soal di array questions (untuk edit mode)
             */
            addTableRow(isEdit, questionIndex) {
                const newRow = { _uid: this.generateUID('row'), statement: '', key: 'col1' };
                if (isEdit && Number.isInteger(questionIndex)) {
                    if (!this.questions[questionIndex].tableData) {
                        this.$set(this.questions[questionIndex], 'tableData', {
                            colStatement: '', col1: 'Benar', col2: 'Salah',
                            rows: [newRow]
                        });
                    } else {
                        this.questions[questionIndex].tableData.rows.push(newRow);
                    }
                } else {
                    if (!this.form.question.tableData) {
                        this.$set(this.form.question, 'tableData', {
                            colStatement: '', col1: 'Benar', col2: 'Salah',
                            rows: [newRow]
                        });
                    } else {
                        this.form.question.tableData.rows.push(newRow);
                    }
                }
            },

            /**
             * Hapus baris pernyataan dari tabel
             */
            removeTableRow(isEdit, questionIndex, rowIndex) {
                if (isEdit && Number.isInteger(questionIndex)) {
                    const row = this.questions[questionIndex].tableData && this.questions[questionIndex].tableData.rows[rowIndex];
                    if (row) {
                        const editorId = 'text-editor-tbl-' + questionIndex + '-row-' + (row._uid || rowIndex);
                        if (window.tinymce && window.tinymce.get(editorId)) {
                            window.tinymce.remove('#' + editorId);
                        }
                    }
                    this.questions[questionIndex].tableData.rows.splice(rowIndex, 1);
                } else {
                    const row = this.form.question.tableData && this.form.question.tableData.rows[rowIndex];
                    if (row) {
                        const editorId = 'text-editor-tbl-create-row-' + (row._uid || rowIndex);
                        if (window.tinymce && window.tinymce.get(editorId)) {
                            window.tinymce.remove('#' + editorId);
                        }
                    }
                    this.form.question.tableData.rows.splice(rowIndex, 1);
                }
            },

            /**
             * Tambah item pilihan di list
             */
            addListItem(isEdit, questionIndex) {
                const newItem = { _uid: this.generateUID('item'), content: '', isCorrect: false };
                if (isEdit && Number.isInteger(questionIndex)) {
                    if (!this.questions[questionIndex].listData) {
                        this.$set(this.questions[questionIndex], 'listData', { items: [newItem] });
                    } else {
                        this.questions[questionIndex].listData.items.push(newItem);
                    }
                } else {
                    if (!this.form.question.listData) {
                        this.$set(this.form.question, 'listData', { items: [newItem] });
                    } else {
                        this.form.question.listData.items.push(newItem);
                    }
                }
            },

            /**
             * Hapus item pilihan dari list
             */
            removeListItem(isEdit, questionIndex, itemIndex) {
                if (isEdit && Number.isInteger(questionIndex)) {
                    const item = this.questions[questionIndex].listData && this.questions[questionIndex].listData.items[itemIndex];
                    if (item) {
                        const editorId = 'text-editor-list-' + questionIndex + '-item-' + (item._uid || itemIndex);
                        if (window.tinymce && window.tinymce.get(editorId)) {
                            window.tinymce.remove('#' + editorId);
                        }
                    }
                    this.questions[questionIndex].listData.items.splice(itemIndex, 1);
                } else {
                    const item = this.form.question.listData && this.form.question.listData.items[itemIndex];
                    if (item) {
                        const editorId = 'text-editor-list-create-item-' + (item._uid || itemIndex);
                        if (window.tinymce && window.tinymce.get(editorId)) {
                            window.tinymce.remove('#' + editorId);
                        }
                    }
                    this.form.question.listData.items.splice(itemIndex, 1);
                }
            },

            /**
             * Generate HTML untuk soal tipe Tabel dari tableData object
             */
            generateTableHTML(tableData) {
                const col1Label = tableData.col1 || 'Benar';
                const col2Label = tableData.col2 || 'Salah';
                const colStmtLabel = tableData.colStatement || 'Pernyataan';

                // Generate defaultAnswer (semua radio tanpa checked)
                let defaultRows = '';
                let answerRows = '';

                tableData.rows.forEach((row, idx) => {
                    const radioName = 'answers[' + idx + ']';
                    const stmtContent = (row.statement || '').trim();

                    // defaultAnswer row (no checked)
                    defaultRows += '<tr>';
                    defaultRows += '<td style="width:45px;min-width:45px;max-width:45px;text-align:center;font-weight:bold;vertical-align:middle;">' + (idx + 1) + '</td>';
                    defaultRows += '<td class="text-justify table-statement-cell" style="text-align:justify !important;text-justify:inter-word;vertical-align:middle;"><div class="statement-scroll-wrap">' + stmtContent + '</div></td>';
                    defaultRows += '<td style="width:80px;min-width:80px;max-width:80px;text-align:center;vertical-align:middle;"><input type="radio" name="' + radioName + '" value="col1" /></td>';
                    defaultRows += '<td style="width:80px;min-width:80px;max-width:80px;text-align:center;vertical-align:middle;"><input type="radio" name="' + radioName + '" value="col2" /></td>';
                    defaultRows += '</tr>';

                    // answer row (with correct answer checked, no disabled so it stays vibrant blue)
                    answerRows += '<tr>';
                    answerRows += '<td style="width:45px;min-width:45px;max-width:45px;text-align:center;font-weight:bold;vertical-align:middle;">' + (idx + 1) + '</td>';
                    answerRows += '<td class="text-justify table-statement-cell" style="text-align:justify !important;text-justify:inter-word;vertical-align:middle;"><div class="statement-scroll-wrap">' + stmtContent + '</div></td>';
                    answerRows += '<td style="width:80px;min-width:80px;max-width:80px;text-align:center;vertical-align:middle;"><input type="radio" name="' + radioName + '" value="col1"' + (row.key === 'col1' ? ' checked="checked"' : '') + ' style="cursor:default;" /></td>';
                    answerRows += '<td style="width:80px;min-width:80px;max-width:80px;text-align:center;vertical-align:middle;"><input type="radio" name="' + radioName + '" value="col2"' + (row.key === 'col2' ? ' checked="checked"' : '') + ' style="cursor:default;" /></td>';
                    answerRows += '</tr>';
                });

                const thead = '<thead><tr><th style="width:45px;min-width:45px;max-width:45px;text-align:center;">No</th><th style="text-align:center;">' + colStmtLabel + '</th><th style="width:80px;min-width:80px;max-width:80px;text-align:center;">' + col1Label + '</th><th style="width:80px;min-width:80px;max-width:80px;text-align:center;">' + col2Label + '</th></tr></thead>';

                const defaultAnswer = '<table border="1" class="table table-bordered mb-0" style="width:100%;table-layout:fixed;">' + thead + '<tbody>' + defaultRows + '</tbody></table>';
                const answer = '<table border="1" class="table table-bordered mb-0" style="width:100%;table-layout:fixed;">' + thead + '<tbody>' + answerRows + '</tbody></table>';

                return { defaultAnswer, answer };
            },

            /**
              * Generate HTML untuk soal tipe List dari listData object
              */
            generateListHTML(listData) {
                let defaultItems = '';
                let answerItems = '';

                listData.items.forEach((item, idx) => {
                    const content = (item.content || '').trim();
                    const checkboxName = 'answers[' + idx + ']';
                    defaultItems += '<li style="list-style:none;margin-bottom:10px;text-align:justify !important;display:flex;align-items:flex-start;width:100%;"><label style="margin-right:10px;margin-top:4px;margin-bottom:0;flex-shrink:0;cursor:pointer;"><input type="checkbox" name="' + checkboxName + '" value="' + idx + '" /></label><div class="list-statement-content" style="flex-grow:1;min-width:0;max-width:100%;overflow-x:auto;overflow-y:hidden;text-align:justify !important;text-justify:inter-word;">' + content + '</div></li>';
                    answerItems += '<li style="list-style:none;margin-bottom:10px;text-align:justify !important;display:flex;align-items:flex-start;width:100%;"><input type="checkbox" name="' + checkboxName + '" value="' + idx + '"' + (item.isCorrect ? ' checked="checked"' : '') + ' onclick="return false;" style="margin-right:10px;margin-top:4px;flex-shrink:0;cursor:default;pointer-events:none;" /><div class="list-statement-content" style="flex-grow:1;min-width:0;max-width:100%;overflow-x:auto;overflow-y:hidden;text-align:justify !important;text-justify:inter-word;pointer-events:auto;">' + content + '</div></li>';
                });

                const defaultAnswer = '<ul class="list-unstyled mb-0" style="list-style:none;padding-left:0;text-align:justify !important;">' + defaultItems + '</ul>';
                const answer = '<ul class="list-unstyled mb-0" style="list-style:none;padding-left:0;text-align:justify !important;">' + answerItems + '</ul>';

                return { defaultAnswer, answer };
            },

            /**
             * Parse HTML soal lama (isEssay=1 yang diakali) menjadi tableData/listData object
             * @param {Object} question - object soal dari API
             */
            parseQuestionData(question) {
                if (question.isEssay !== 1 && question.isEssay !== 2 && question.isEssay !== 3) return question;

                // Bersihkan atribut disabled pada answer agar radio/checkbox selalu tampil biru cerah normal
                // dan pastikan statement terbungkus statement-scroll-wrap agar header tidak ikut tergeser
                if (question.answer && typeof question.answer === 'string') {
                    question.answer = question.answer.replace(/\sdisabled(="[^"]*")?/gi, '');
                    if (question.answer.includes('<table') && question.answer.includes('type="radio"')) {
                        try {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(question.answer, 'text/html');
                            const table = doc.querySelector('table');
                            let modified = false;
                            if (table && table.style.tableLayout !== 'fixed') {
                                table.style.tableLayout = 'fixed';
                                table.style.width = '100%';
                                modified = true;
                            }
                            const rows = doc.querySelectorAll('tbody tr');
                            rows.forEach(tr => {
                                const cells = tr.querySelectorAll('td');
                                if (cells.length >= 4) {
                                    const stmtCell = cells[1];
                                    if (!stmtCell.querySelector('.statement-scroll-wrap')) {
                                        const wrap = doc.createElement('div');
                                        wrap.className = 'statement-scroll-wrap';
                                        while (stmtCell.firstChild) {
                                            wrap.appendChild(stmtCell.firstChild);
                                        }
                                        stmtCell.appendChild(wrap);
                                        modified = true;
                                    }
                                }
                            });
                            if (modified) {
                                question.answer = doc.body.innerHTML;
                            }
                        } catch (e) {}
                    }
                    if (question.answer.includes('<ul') && question.answer.includes('type="checkbox"')) {
                        try {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(question.answer, 'text/html');
                            let modified = false;
                            doc.querySelectorAll('ul li').forEach((li, idx) => {
                                const cb = li.querySelector('input[type="checkbox"]');
                                const isChecked = cb ? (cb.checked || cb.hasAttribute('checked')) : false;
                                const contentDiv = li.querySelector('.list-statement-content');
                                let content = '';
                                if (contentDiv) {
                                    content = contentDiv.innerHTML.trim();
                                } else {
                                    const clone = li.cloneNode(true);
                                    clone.querySelectorAll('input').forEach(inp => inp.remove());
                                    content = clone.innerHTML.trim();
                                }
                                const cbName = 'answers[' + idx + ']';
                                li.innerHTML = '<input type="checkbox" name="' + cbName + '" value="' + idx + '"' + (isChecked ? ' checked="checked"' : '') + ' onclick="return false;" style="margin-right:10px;margin-top:4px;flex-shrink:0;cursor:default;pointer-events:none;" /><div class="list-statement-content" style="flex-grow:1;min-width:0;max-width:100%;overflow-x:auto;overflow-y:hidden;text-align:justify !important;text-justify:inter-word;pointer-events:auto;">' + content + '</div>';
                                li.style.display = 'flex';
                                li.style.alignItems = 'flex-start';
                                li.style.width = '100%';
                                modified = true;
                            });
                            if (modified) {
                                question.answer = doc.body.innerHTML;
                            }
                        } catch (e) {}
                    }
                }

                const answerHTML = question.answer || '';
                const defaultAnswerHTML = question.defaultAnswer || '';

                // Deteksi: apakah HTML mengandung tabel dengan radio button?
                const hasTable = answerHTML.includes('<table') && answerHTML.includes('type="radio"');
                // Deteksi: apakah HTML mengandung ul dengan checkbox?
                const hasList = answerHTML.includes('<ul') && (answerHTML.includes('type="checkbox"'));

                if ((question.isEssay === 1 || question.isEssay === 2) && hasTable) {
                    // Parse sebagai tabel
                    question.isEssay = 2;
                    try {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(answerHTML, 'text/html');
                        const table = doc.querySelector('table');
                        if (table) {
                            const headers = table.querySelectorAll('thead th');
                            const col1Label = headers[2] ? headers[2].textContent.trim() : 'Benar';
                            const col2Label = headers[3] ? headers[3].textContent.trim() : 'Salah';
                            const colStmtLabel = headers[1] ? headers[1].textContent.trim() : 'Pernyataan';

                            const rows = [];
                            table.querySelectorAll('tbody tr').forEach(tr => {
                                const cells = tr.querySelectorAll('td');
                                if (cells.length >= 4) {
                                    const stmtCell = cells[1];
                                    // Remove radio buttons from statement cell if any
                                    const stmtClone = stmtCell.cloneNode(true);
                                    stmtClone.querySelectorAll('input').forEach(inp => inp.remove());
                                    const scrollWrap = stmtClone.querySelector('.statement-scroll-wrap');
                                    let statement = scrollWrap ? scrollWrap.innerHTML.trim() : stmtClone.innerHTML.trim();
                                    statement = statement.replace(/(<p>(&nbsp;|\s)*<\/p>|<br\s*\/?>)+$/gi, '').trim();

                                    const radio1 = cells[2].querySelector('input[type="radio"]');
                                    const radio2 = cells[3].querySelector('input[type="radio"]');
                                    const key = (radio1 && radio1.checked) ? 'col1' : (radio2 && radio2.checked) ? 'col2' : 'col1';

                                    rows.push({ _uid: this.generateUID('row'), statement, key });
                                }
                            });

                            question.tableData = { colStatement: colStmtLabel, col1: col1Label, col2: col2Label, rows: rows.length ? rows : [{ _uid: this.generateUID('row'), statement: '', key: 'col1' }] };
                        }
                    } catch (e) {
                        question.tableData = { colStatement: '', col1: 'Benar', col2: 'Salah', rows: [{ _uid: this.generateUID('row'), statement: '', key: 'col1' }] };
                    }
                } else if ((question.isEssay === 1 || question.isEssay === 3) && hasList) {
                    // Parse sebagai list
                    question.isEssay = 3;
                    try {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(answerHTML, 'text/html');
                        const ul = doc.querySelector('ul');
                        if (ul) {
                            const items = [];
                            ul.querySelectorAll('li').forEach(li => {
                                const checkbox = li.querySelector('input[type="checkbox"]');
                                const isCorrect = checkbox ? (checkbox.checked || checkbox.hasAttribute('checked')) : false;

                                const contentDiv = li.querySelector('.list-statement-content');
                                let content = '';
                                if (contentDiv) {
                                    content = contentDiv.innerHTML.trim();
                                } else {
                                    const liClone = li.cloneNode(true);
                                    liClone.querySelectorAll('input').forEach(inp => inp.remove());
                                    content = liClone.innerHTML.trim();
                                }
                                items.push({ _uid: this.generateUID('item'), content, isCorrect });
                            });
                            question.listData = { items: items.length ? items : [{ _uid: this.generateUID('item'), content: '', isCorrect: false }] };
                        }
                    } catch (e) {
                        question.listData = { items: [{ _uid: this.generateUID('item'), content: '', isCorrect: false }] };
                    }
                }

                // Pastikan tableData/listData selalu ada untuk edit yang tepat dan memiliki _uid
                if (question.isEssay === 2) {
                    if (!question.tableData) {
                        question.tableData = { colStatement: '', col1: 'Benar', col2: 'Salah', rows: [{ _uid: this.generateUID('row'), statement: '', key: 'col1' }] };
                    } else if (question.tableData.rows) {
                        question.tableData.rows.forEach(r => {
                            if (!r._uid) r._uid = this.generateUID('row');
                        });
                    }
                }
                if (question.isEssay === 3) {
                    if (!question.listData) {
                        question.listData = { items: [{ _uid: this.generateUID('item'), content: '', isCorrect: false }] };
                    } else if (question.listData.items) {
                        question.listData.items.forEach(it => {
                            if (!it._uid) it._uid = this.generateUID('item');
                        });
                    }
                }

                if (question.isEssay === 1) {
                    const isNum = !!(question.defaultAnswer && question.defaultAnswer.includes('data-numeric="true"'));
                    this.$set(question, 'essayType', isNum ? 'numeric' : 'text');
                    if (isNum && question.defaultAnswer) {
                        const cleanDef = question.defaultAnswer
                            .replace(/<div[^>]*class="essay-numeric-input"[^>]*>/gi, '')
                            .replace(/<div[^>]*data-numeric="true"[^>]*>/gi, '')
                            .replace(/<\/div>/gi, '')
                            .trim();
                        question.defaultAnswer = cleanDef;
                    }
                }

                return question;
            },
        },
        created() {
            this.overrideTinyMCEOptions();
            this.page = parseInt(this.$route.params.page) || 1;
            this.form.filter.packageID = parseInt(this.$route.params.packageID) || '';
            this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.id).then(response => {
                this.tryout = response.data.data;
                if (!this.tryout.tryoutOnline) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Tryout online not found'}});
                }
                if (this.tryout.tryoutGroups.length) {
                    for (var i = 0; i < this.tryout.tryoutGroups.length; i++) {
                        this.tryoutSubject = this.tryout.tryoutGroups[i].tryoutSubjects.find(tryoutSubject => tryoutSubject.id === parseInt(this.$route.params.tryoutSubjectID));
                        if (this.tryoutSubject) {
                            break;
                        }
                    }
                } else {
                    this.tryoutSubject = this.tryout.tryoutSubjects.find(tryoutSubject => tryoutSubject.id === parseInt(this.$route.params.tryoutSubjectID));
                }
                if (!this.tryoutSubject) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Subject Not found'}});
                }
                this.pageCount = Math.ceil(this.tryoutSubject.totalQuestion / this.perPage);

                this.paginate(this.page);
                document.title = 'Tryout Online ' + this.tryout.name + ' - ' + this.tryoutSubject.subject.name + ' ' + this.tryoutSubject.code + ' - ' + process.env.APP_NAME;
            }).catch((error) => {
                this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
            });

        }
    };
</script>

<style scoped>
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }

    h1:empty, h2:empty, h3:empty, h4:empty, h5:empty, h6:empty,
    p:empty, .text-loading:empty, img:not([src]), img[src=""]{
        display: none;
    }

    /* Style Justify untuk Kolom Tanggapan (Tabel) dan Item Pilihan (List) */
    .table-responsive /deep/ td.text-justify,
    .table-responsive /deep/ td.text-justify p,
    .table-responsive /deep/ td.table-statement-cell,
    .table-responsive /deep/ td.table-statement-cell p,
    .table-responsive /deep/ td:nth-child(2),
    .table-responsive /deep/ td:nth-child(2) p {
        text-align: justify !important;
        text-justify: inter-word !important;
        margin-bottom: 0 !important;
    }

    .table-responsive /deep/ .list-statement-content,
    .table-responsive /deep/ .list-statement-content p,
    .table-responsive /deep/ ul li,
    .table-responsive /deep/ ul li label,
    .table-responsive /deep/ ul li div,
    .table-responsive /deep/ ul li p {
        text-align: justify !important;
        text-justify: inter-word !important;
        margin-bottom: 0 !important;
    }

    /* Kunci Tabel & Kunci List di Mode Tampilan (Bukan Mode Edit) */
    .locked-answer-view {
        width: 100%;
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
        cursor: default;
    }

    /* Pastikan warna radio & checkbox kunci tetap BIRU cerah (tidak abu-abu/faded) */
    .locked-answer-view /deep/ input[type="radio"],
    .locked-answer-view /deep/ input[type="checkbox"] {
        accent-color: #007bff !important;
        opacity: 1 !important;
        filter: none !important;
        -webkit-filter: none !important;
        cursor: default !important;
        pointer-events: none !important;
    }

    /* Hanya kunci interaksi pada input dan label, agar tabel tetap bisa digeser/scroll */
    .locked-answer-view /deep/ label {
        pointer-events: none !important;
        cursor: default !important;
    }

    /* Hover baris tabel berubah warna seperti Pusmendik */
    .locked-answer-view /deep/ tbody tr {
        transition: background-color 0.15s ease-in-out;
    }
    .locked-answer-view /deep/ tbody tr:hover td {
        background-color: #edf4fc !important;
    }

    /* Hover baris list berubah warna biru muda */
    .locked-answer-view /deep/ ul li {
        transition: background-color 0.15s ease-in-out;
        border-radius: 4px;
        padding: 4px 8px;
    }
    .locked-answer-view /deep/ ul li:hover {
        background-color: #edf4fc !important;
    }

    /* Konten item list dapat di-scroll horizontal jika ada gambar panjang */
    .locked-answer-view /deep/ .list-statement-content {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
        min-width: 0;
    }

    /* Matikan drag pada gambar */
    .locked-answer-view /deep/ img {
        -webkit-user-drag: none !important;
        user-drag: none !important;
        user-select: none !important;
        -webkit-user-select: none !important;
    }

    /* Tabel dengan fixed layout agar header tidak bergeser dan lebarnya pas dengan container */
    .locked-answer-view /deep/ table {
        table-layout: fixed !important;
        width: 100% !important;
        max-width: 100% !important;
        border-collapse: collapse !important;
        margin-bottom: 0 !important;
    }

    .locked-answer-view /deep/ table.table-bordered th,
    .locked-answer-view /deep/ table.table-bordered td {
        border: 1px solid #dee2e6 !important;
    }

    /* Kolom 1 (No) */
    .locked-answer-view /deep/ th:nth-child(1),
    .locked-answer-view /deep/ td:nth-child(1) {
        width: 45px !important;
        min-width: 45px !important;
        max-width: 45px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
    }

    .locked-answer-view /deep/ thead th:nth-child(1) {
        background-color: #f8f9fa !important;
    }

    /* Kolom 2 (Statement) Header tetap di tengah dan tidak bergeser */
    .locked-answer-view /deep/ thead th:nth-child(2) {
        text-align: center !important;
        background-color: #f8f9fa !important;
        vertical-align: middle !important;
        width: auto !important;
    }

    /* Kolom 2 (Statement) Baris data di bawah header: hanya konten pernyataan yang bisa digeser jika ada foto panjang */
    .locked-answer-view /deep/ td.table-statement-cell,
    .locked-answer-view /deep/ td:nth-child(2) {
        width: auto !important;
        vertical-align: middle !important;
        padding-top: 0.6rem !important;
        padding-bottom: 0.6rem !important;
        overflow: hidden !important;
    }

    .locked-answer-view /deep/ .statement-scroll-wrap {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
        margin: 0 !important;
        padding: 0 !important;
    }

    .locked-answer-view /deep/ .statement-scroll-wrap p,
    .locked-answer-view /deep/ td.table-statement-cell p {
        margin: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding: 0 !important;
        line-height: 1.5 !important;
    }

    .locked-answer-view /deep/ .statement-scroll-wrap p:not(:last-child),
    .locked-answer-view /deep/ td.table-statement-cell p:not(:last-child) {
        margin-bottom: 0.35rem !important;
    }

    .locked-answer-view /deep/ .statement-scroll-wrap p:empty,
    .locked-answer-view /deep/ td.table-statement-cell p:empty {
        display: none !important;
    }

    /* Kolom 3 (Pilihan 1 / Yes) */
    .locked-answer-view /deep/ th:nth-child(3),
    .locked-answer-view /deep/ td:nth-child(3) {
        width: 80px !important;
        min-width: 80px !important;
        max-width: 80px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
    }

    .locked-answer-view /deep/ thead th:nth-child(3) {
        background-color: #f8f9fa !important;
    }

    /* Kolom 4 (Pilihan 2 / No) */
    .locked-answer-view /deep/ th:nth-child(4),
    .locked-answer-view /deep/ td:nth-child(4) {
        width: 80px !important;
        min-width: 80px !important;
        max-width: 80px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
    }

    .locked-answer-view /deep/ thead th:nth-child(4) {
        background-color: #f8f9fa !important;
    }

    /* Gambar di dalam tabel & list mempertahankan ukuran aslinya agar tetap terbaca jelas */
    /* mix-blend-mode multiply menyatukan background putih gambar dengan warna biru muda baris saat dihover */
    .locked-answer-view /deep/ td.table-statement-cell img,
    .locked-answer-view /deep/ td:nth-child(2) img,
    .locked-answer-view /deep/ td img,
    .locked-answer-view /deep/ .statement-scroll-wrap img,
    .locked-answer-view /deep/ .list-statement-content img,
    .locked-answer-view /deep/ ul li img,
    .table-responsive /deep/ td.table-statement-cell img,
    .table-responsive /deep/ td img {
        max-width: none !important;
        height: auto !important;
        display: inline-block !important;
        mix-blend-mode: multiply !important;
        background-color: transparent !important;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }

    /* Scrollbar horizontal rapi: track transparan agar tidak muncul kotak/garis abu-abu di bawah teks biasa */
    .locked-answer-view /deep/ .statement-scroll-wrap::-webkit-scrollbar,
    .locked-answer-view /deep/ .list-statement-content::-webkit-scrollbar {
        height: 6px;
    }
    .locked-answer-view /deep/ .statement-scroll-wrap::-webkit-scrollbar-track,
    .locked-answer-view /deep/ .list-statement-content::-webkit-scrollbar-track {
        background: transparent !important;
    }
    .locked-answer-view /deep/ .statement-scroll-wrap::-webkit-scrollbar-thumb,
    .locked-answer-view /deep/ .list-statement-content::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    .locked-answer-view /deep/ .statement-scroll-wrap::-webkit-scrollbar-thumb:hover,
    .locked-answer-view /deep/ .list-statement-content::-webkit-scrollbar-thumb:hover {
        background: #888;
    }

    /* Deskripsi Soal: jika gambar sangat panjang, pertahankan ukuran aslinya & bisa digeser */
    /deep/ .question-content-wrap {
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch;
        max-width: 100% !important;
    }

    /deep/ .question-content-wrap img {
        max-width: none !important;
        height: auto !important;
        display: inline-block !important;
    }

    /* Scrollbar horizontal rapi untuk Deskripsi Soal: track transparan */
    /deep/ .question-content-wrap::-webkit-scrollbar {
        height: 6px;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-track {
        background: transparent !important;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-thumb:hover {
        background: #888;
    }
</style>


// WEBPACK FOOTER //
// src/components/tryout/online/question/View.vue